
export default class TeamMember {
    constructor(
        private readonly selectTeamMemberFunc: (TeamMember) => void,
        public readonly name: string,
        public readonly jobTitle: string,
        public readonly description: string,
        public readonly imgSrc: string
    ) { }

    public select(): void {
        this.selectTeamMemberFunc(this);
    }

    public deselect(): void {
        this.selectTeamMemberFunc(null);
    }
}